import React from "react";
import { FaHeart } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "../NewIPDPatientAdmission.module.css";

const VitalSigns = ({ formData, handleInputChange }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.section}>
      <h3><FaHeart /> {t("Vital Signs")}</h3>
      <div className={styles.grid6}>
        <input type="number" step="any" name="height" value={formData.height} onChange={handleInputChange} placeholder={t("Height (cm)")} />
        <input type="number" step="any" name="weight" value={formData.weight} onChange={handleInputChange} placeholder={t("Weight (kg)")} />
        <input type="number" step="any" name="bp_systolic" value={formData.bp_systolic} onChange={handleInputChange} placeholder={t("BP Systolic (mmHg)")} />
        <input type="number" step="any" name="bp_diastolic" value={formData.bp_diastolic} onChange={handleInputChange} placeholder={t("BP Diastolic (mmHg)")} />
        <input type="number" step="any" name="pulse" value={formData.pulse} onChange={handleInputChange} placeholder={t("Pulse (bpm)")} />
        <input type="number" step="any" name="temperature" value={formData.temperature} onChange={handleInputChange} placeholder={t("Temperature (°F)")} />
        <input type="number" step="any" name="spo2" value={formData.spo2} onChange={handleInputChange} placeholder={t("SpO2 (%)")} />
      </div>
    </div>
  );
};

export default VitalSigns;
